export const vscodeTheme = {
  colors: {
    // VSCode Dark Theme colors
    sidebarBackground: '#252526',
    editorBackground: '#1e1e1e',
    headerBackground: '#3c3c3c',
    textPrimary: '#cccccc',
    textSecondary: '#858585',
    border: '#2b2b2b',
    hoverBackground: '#2a2d2e',
    selectedBackground: '#37373d',
    dropBackground: '#2a2d2e',
    inputBackground: '#3c3c3c',
    contextMenuBackground: '#252526',
    contextMenuBorder: '#454545',
    activeBackground: '#37373d',
    focusBorder: '#007fd4',
    buttonBackground: '#0e639c',
    buttonHoverBackground: '#1177bb',
    error: '#f14c4c',
  },
  typography: {
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    fontSize: '13px',
    monospaceFontFamily: "'Consolas', 'Courier New', monospace",
  },
};
